import { Box, IconButton, Paper, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ProductPopularity } from '../../interfaces/PopularProduct/ProductPopularity';
import { sharedColors, sharedStyles } from '../../utils/Style';

type ProductPopularityChipProps = {
  entry: ProductPopularity;
  onDelete: () => void;
  onMoveRight?: () => void;
  onMoveLeft?: () => void;
};

export const ProductPopularityChip = (props: ProductPopularityChipProps) => {
  const iconButtonStyle = {
    color: sharedColors.white,
    p: 0,
    minHeight: 0,
    minWidth: 0,
  };

  return (
    <Paper sx={{ backgroundColor: sharedColors.primary, p: 1.25 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <IconButton size='small' onClick={props.onDelete} sx={iconButtonStyle}>
          <CancelIcon />
        </IconButton>
        <Typography sx={{ ...sharedStyles.body1, color: sharedColors.white }}>
          {props.entry.name}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }}>
          <IconButton
            size='small'
            disabled={!props.onMoveLeft}
            onClick={props.onMoveLeft}
            sx={iconButtonStyle}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            size='small'
            disabled={!props.onMoveRight}
            onClick={props.onMoveRight}
            sx={iconButtonStyle}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};
